var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MonacoEditor',{staticClass:"border",attrs:{"height":272,"value":_vm.value,"language":_vm.language,"options":{
    automaticLayout: true,
    minimap: {
      enabled: false,
    },
  }},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }